// extracted by mini-css-extract-plugin
export default {"infoContainer":"PhotoWithReference_infoContainer__n6nYI","imageUpload":"PhotoWithReference_imageUpload__oRRza"};